import React, { useRef, useEffect, useState } from "react";
import _ from "lodash";
import moment from "moment";
import Draw from "./ClaimDetailsDraw";
import ClaimDetailsTable from "./ClaimDetailsTable";
import PharmacyEncounterClaimDetailsTable from "./PharmacyEncounterClaimDetailsTable";
import MedicalEncounterClaimDetailsTable from "./MedicalEncounterClaimDetailsTable";
import { wholeNumberWithCommas } from "../../utils/NumberFormatter";
import Notice from "../../Notice";
import Http from "../http";
import useDeepCompareEffect from "../../Hooks/useDeepCompareEffect";
import Paginate from "../../utils/Paginate";
import StatCard from "../../StatCard";
import StatCardsContainer from "../../StatCardsContainer";
const CLAIM_TYPE_LABELS = {
  pharmacy: "Pharmacy",
  medical: "Medical",
  pharmacy_encounter: "Pharmacy Encounter",
  medical_encounter: "Medical Encounter",
};

const ClaimDetailsIndex = (props) => {
  const [notice, setNotice] = React.useState({
    kind: "error",
    open: false,
    message: "",
  });

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const entityID = urlParams.get("id");

  const [searchQuery, setSearchQuery] = useState({
    id_340b: entityID ? entityID : props.entities[0].value,
    manufacturer: props.manufacturers[0].value,
    date_range: {
      start: moment().startOf("month").format("YYYY-MM-DD"),
      end: moment().format("YYYY-MM-DD"),
    },
  });
  const [claims, setClaims] = useState([]);
  const [isClaimsLoading, setIsClaimsLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPageIndex, setCurrentPageIndex] = useState(0);
  const [conformingClaimsCount, setConformingClaimsCount] = useState(0);
  const [conformingClaimsPercent, setConformingClaimsPercent] = useState(0);
  const [nonConformingClaimsCount, setNonConformingClaimsCount] = useState(0);

  useDeepCompareEffect(() => {
    fetch();
  }, [searchQuery, currentPageIndex]);

  const fetch = async () => {
    if (!searchQuery.date_range.start || !searchQuery.date_range.end) return;
    setIsClaimsLoading(true);
    const pagedQuery = { ...searchQuery, page: currentPageIndex + 1 };

    await Http.fetchQuery(props.query_path, pagedQuery)
      .then((res) => {
        if (_.isEmpty(res.claims)) {
          setNotice({
            kind: "success",
            open: true,
            message: "The current selection and filters returned no results",
          });
        }
        setClaims(res.claims);
        setTotalPages(res.total_pages);
        setConformingClaimsCount(res.conforming_claims_count);
        setConformingClaimsPercent(res.conforming_claims_percent);
        setNonConformingClaimsCount(res.non_conforming_claims_count);
      })
      .catch((error) => {
        setNotice({ kind: "error", open: true, message: "Error fetching data" });
      })
      .finally(() => setIsClaimsLoading(false));
  };

  const handleSearch = (name, value) => {
    setSearchQuery({ ...searchQuery, [name]: value });
  };

  const handleSort = (column, dir) => {
    setSearchQuery({ ...searchQuery, sort: column, sort_dir: dir });
  };

  const stats = [
    { title: "Conforming Claims", figure: wholeNumberWithCommas(conformingClaimsCount) },
    { title: "% Conforming Claims", figure: `${conformingClaimsPercent}%` },
    { title: "Non-Conforming Claims", figure: wholeNumberWithCommas(nonConformingClaimsCount) },
  ];

  return (
    <div style={{ display: "flex" }}>
      <div className="content__container">
        <div className="page-details__container">
          <div className="page-details__container__info mb--14">
            <div className="page-details__title">
              {CLAIM_TYPE_LABELS[props.claimType] || props.claimType} Claims Details
            </div>
            <div className="breadcrumbs__container">
              <div className="breadcrumbs__crumb breadcrumbs__crumb__active">Reports</div>
            </div>
          </div>
          <StatCardsContainer>
            {stats.map((stat, i) => (
              <StatCard key={i} title={stat.title} figure={stat.figure} />
            ))}
          </StatCardsContainer>
        </div>
        {totalPages > 1 && (
          <Paginate totalPages={totalPages} setCurrentPage={setCurrentPageIndex} />
        )}
        {props.claimType === "pharmacy_encounter" ? (
          <PharmacyEncounterClaimDetailsTable
            claims={claims}
            isLoading={isClaimsLoading}
            handleSort={handleSort}
          />
        ) : props.claimType === "medical_encounter" ? (
          <MedicalEncounterClaimDetailsTable
            claims={claims}
            isLoading={isClaimsLoading}
            handleSort={handleSort}
          />
        ) : (
          <ClaimDetailsTable
            claimType={props.claimType}
            claims={claims}
            isLoading={isClaimsLoading}
            handleSort={handleSort}
          />
        )}
      </div>
      <div className="draw__container">
        <Draw
          entities={props.entities}
          setSearchQuery={setSearchQuery}
          searchQuery={searchQuery}
          handleSearch={handleSearch}
          manufacturers={props.manufacturers}
          products={props.products}
          issues={props.issues}
          warnings={props.warnings}
        />
      </div>
      <Notice details={notice} />
    </div>
  );
};

export default ClaimDetailsIndex;
